import { render, staticRenderFns } from "./MedicationEntry.vue?vue&type=template&id=37d889f1&scoped=true"
import script from "./MedicationEntry.vue?vue&type=script&lang=js"
export * from "./MedicationEntry.vue?vue&type=script&lang=js"
import style0 from "./MedicationEntry.vue?vue&type=style&index=0&id=37d889f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d889f1",
  null
  
)

export default component.exports